import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    products: [],
    quantity: 0,
    total: 0,
  },
  reducers: {
    addProduct: (state, action) => {
      // this quantity represents the quantity of all the product
      state.quantity += 1;
      // action/payload is t
      state.products.push(action.payload);
      // action.payload.quantity is the number of quantity of that specific product
      state.total += action.payload.price * action.payload.quantity;
    },
  },
});

export const { addProduct } = cartSlice.actions;
export default cartSlice.reducer;
